<script>
  import Iframe from "./Iframe.svelte";
  import { getContext } from "svelte";

  export let data;
  export let hideControls = false;
  let heroEmbedClass = !!getContext("isLandingPageHeroChild");

  // https://developers.google.com/youtube/player_parameters#Parameters
  const defaultOptions = {
    rel: "0", // show related videos from same channel
    controls: hideControls ? 0 : 1, // show or hide controls
    modestbranding: 1 // hide YouTube branding, not in effect when controls are hidden
  };
  function getModifiedTarget(dataUrl) {
    const url = new URL(dataUrl.replace("watch?v=", "embed/"));
    const params = url.searchParams;
    Object.entries(defaultOptions).forEach(([key, val]) => params.set(key, val));
    return `${url.origin}${url.pathname}?${params}`;
  }
  $: target = getModifiedTarget(data.fields.url);
</script>

<div
  class="embedded-content"
  class:hero-youtube-embed={heroEmbedClass}
  class:lg:!py-[27px]={heroEmbedClass}
>
  <Iframe
    title={data.fields.title}
    src={target}
    allowfullscreen
    class="{heroEmbedClass
      ? 'aspect-video lg:aspect-[unset] h-[calc(100vh-136px-27px)] max-h-[calc(100vw*9/16)] lg:max-h-[calc((100vw-43px*2)*9/16)]'
      : 'aspect-video'} w-full"
  >
    <a href={target} target="_blank" rel="noopener noreferrer" slot="fallback">
      Watch this YouTube video in a new tab
    </a>
  </Iframe>
</div>

<!--I've styled this embed (when used within a hero) with vanilla CSS since I don't believe we have support for
using calc() with Tailwind. This embed is inside of several boxes which limit its width, and though I can use
w-screen with Tailwind, I can't find a clean way to adjust the margins properly as the YouTube embed is placed
inside of a RichText body when used in a hero. -Christina -->
<style>
  @media (min-width: 1366px) {
    div.hero-youtube-embed {
      width: calc(100vw - 86px);
      margin-left: calc(-1 * (50vw - 50%) + 43px);
    }
  }
</style>
